import React, { useState } from 'react';
import { ActivityRendererProps } from './types';

const MCQActivity: React.FC<ActivityRendererProps> = ({ activity, onComplete }) => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState<number[]>([]);
  const [showResults, setShowResults] = useState(false);
  const [score, setScore] = useState(0);

  const questions = activity.content.questions;
  const currentQuestion = questions[currentQuestionIndex];

  const handleAnswerSelect = (answerIndex: number) => {
    const newAnswers = [...selectedAnswers];
    newAnswers[currentQuestionIndex] = answerIndex;
    setSelectedAnswers(newAnswers);
  };

  const handleNextQuestion = () => {
    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    } else {
      const correctAnswers = selectedAnswers.reduce((count, answer, index) => {
        return count + (answer === questions[index].correctAnswer ? 1 : 0);
      }, 0);
      const finalScore = Math.round((correctAnswers / questions.length) * 100);
      setScore(finalScore);
      setShowResults(true);
    }
  };

  const handleCompleteActivity = () => {
    onComplete(score);
  };

  if (showResults) {
    return (
      <div className="mcq-results">
        <h3>Quiz Results</h3>
        <div className="score-display">
          <span className="score-value">{score}%</span>
          <span className="score-label">
            {selectedAnswers.filter((answer, index) => answer === questions[index].correctAnswer).length} / {questions.length} correct
          </span>
        </div>
        <button className="complete-btn" onClick={handleCompleteActivity}>
          Continue to Next Activity
        </button>
      </div>
    );
  }

  return (
    <div className="mcq-activity">
      <div className="question-progress">
        Question {currentQuestionIndex + 1} of {questions.length}
      </div>
      
      <div className="question-content">
        <h3 className="question-text">{currentQuestion.question}</h3>
        
        <div className="answer-options">
          {currentQuestion.options.map((option: string, index: number) => (
            <button
              key={index}
              className={`answer-option ${selectedAnswers[currentQuestionIndex] === index ? 'selected' : ''}`}
              onClick={() => handleAnswerSelect(index)}
            >
              {option}
            </button>
          ))}
        </div>
      </div>
      
      <div className="mcq-actions">
        <button 
          className="next-question-btn"
          onClick={handleNextQuestion}
          disabled={selectedAnswers[currentQuestionIndex] === undefined}
        >
          {currentQuestionIndex === questions.length - 1 ? 'Finish Quiz' : 'Next Question'}
        </button>
      </div>
    </div>
  );
};

export default MCQActivity;

